import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ReportDialogFacade } from 'src/app/_core/state/dialogs/report/report.facade';
import { Rating } from 'src/app/models/rating';
import { Record } from 'src/app/models/record';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { ToastService } from '../../_core/services/toast.service';

@Component({
  selector: 'app-record-interactions',
  templateUrl: './record-interactions.component.html',
  styleUrls: ['./record-interactions.component.scss'],
})
export class RecordInteractionsComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  @Input()
  record: Record;

  @Input()
  rating: Rating;

  @Output()
  ratedEvent: EventEmitter<Rating> = new EventEmitter();

  private readonly reportDialogFacade = inject(ReportDialogFacade);

  user: User;
  readOnly = true;
  socialButtons: string[];
  shareText: string;
  showWikipediaLink: boolean;
  showSocialIcons: boolean;
  showReportIssueButton: boolean;
  textDirection: string;

  constructor(
    private authService: AuthService,
    private localeService: LocaleService,
    private configService: ConfigService,
    private dialog: MatDialog
  ) {
    this.user = this.authService.getLoggedUser();
    if (this.user) {
      this.readOnly = false;
    }

    this.socialButtons = this.configService.shareIcons;
    this.showSocialIcons = this.configService.get().showSocialIcons;
    this.showWikipediaLink = this.configService.get().showWikipediaLink;
    this.showReportIssueButton =
      this.user &&
      (this.configService.get().showReportIssueButton === undefined
        ? true
        : this.configService.get().showReportIssueButton);
    this.textDirection = localeService.getTextDirection();
  }

  ngOnInit() {
    this.shareText = this.localeService.getLocalizedShareText(this.record, this.configService.get().title);
  }

  onRecordRated(rating: Rating) {
    this.rating = rating;
    this.ratedEvent.emit(rating);
  }

  goToWikipedia(author: string) {
    const lang = this.localeService.language;
    const url = `https://${lang}.wikipedia.org/wiki/Special:Search?search=${author}`;
    window.open(url, '_blank', 'noopener');
  }

  handleOpenedEvent(event: string) {
    if (event === 'copy') {
      Util.copyToClipboard(window.location.href);
      this.toastService.showToast('messages.copied', 'info');
    }
  }

  openReportDialog() {
    this.reportDialogFacade.openDialog();
  }
}
